export default __webpack_public_path__ + "static/media/sparck-mountain-waves-yellow.a593a0e9.png";